import React, { Component } from 'react';
import './styles.css';

import Table from '../../../../components/Table';

const DischargesFieldTypes = {
  RECEIVED_BY_LUFT: 1,
  CITY: 2,
  RECIPIENT: 3,
  DRIVER: 4,
  PLATE: 5,
  MANIFEST: 6,
  CTE: 7,
  STATUS: 8,
};

export default class DischargeTable extends Component {
  _onRowClick = (cells, row) => {
    const { openDetailsDrawer } = this.props;
    openDetailsDrawer(row);
  }
  render() {
    const {
      data,
      onOrderColumn,
      dataOrder,
    } = this.props;
    return (
      <Table
        onRowClick={this._onRowClick}
        className="ManifestsInTransit__table"
        isFetching={false}
        wrapCells
        onOrderColumn={onOrderColumn}
        dataOrder={dataOrder}
        headers={[
          {
            title: 'Data e hora da baixa',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.RECEIVED_BY_LUFT,
          },
          {
            title: 'UF / Cidade',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.CITY,
          },
          {
            title: 'Destinatário',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.RECIPIENT,
          },
          {
            title: 'Motorista',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.DRIVER,
          },
          {
            title: 'Placa',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.PLATE,
          },
          {
            title: 'Manifesto',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.MANIFEST,
          },
          {
            title: 'CTE',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.CTE,
          },
          {
            title: 'Baixa / Foto',
            highlighted: true,
            alignment: 'center',
            fieldType: DischargesFieldTypes.STATUS,
          },
        ]}
        data={data}
      />
    );
  }
}
